<template>
  <v-dialog
    :value="isDialogOpen"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title class="text-capitalize">
        {{ title }}
      </v-card-title>

      <v-card-text>{{ confirmationMessage }}</v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="error"
          :disabled="isLoading"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="success"
          @click="handleSubmitBtnClick"
        >
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="secundary"
          />

          <span v-else>Confirmar</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import useDialog from '@/composables/useDialog'

export default {
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    confirmationMessage: {
      type: String,
      required: true,
    },
    confirm: {
      type: Function,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { closeDialog, emitRefetchData } = useDialog(emit, 'isDialogOpen')

    async function handleSubmitBtnClick() {
      await props.confirm()
      emitRefetchData()
      closeDialog()
    }

    return {
      closeDialog,
      handleSubmitBtnClick,
    }
  },
}
</script>
